<div class="ni" [class.text-nowrap]="!(nome?.length >0)">
    <span class="link" tooltip="Consultar os Dados Cadastrais" container="body" boundariesElement="viewport" (click)='solicitaDadosBasicos()'>
        {{(niAjustado | formatCpfCnpjPipe)}}
    </span>
    <span *ngIf="nome?.length > 0"> - {{nome}} </span>
    <span class="material-icons cursor" tooltip="Consultar a Situação Fiscal" container="body" boundariesElement="viewport" (click)="solicitaAtendimento()">search</span>
</div>

<suite-rfb-confirmation #confirmaSolicitacaoAtendimento
                        [customBody]="perguntaAtendimento"
                        (accept)="this.fecharTodosModais()">
</suite-rfb-confirmation>

<ng-template #perguntaAtendimento>
    <div style="width: 480px">
        <span>{{ "Você deseja fechar todos os pop-ups abertos para acessar a tela de atendimento?" }}</span>
    </div>
</ng-template>